// extracted by mini-css-extract-plugin
export default {"button":"AddToBasket__button--XghTb","active":"AddToBasket__active--KD_Rz"};